module.exports = __webpack_public_path__ + "img/small.4f6b522e.jpg";